// Used by the work order list pages.
// Work orders cannot be closed here if ToC applies, if they are already open, or
// if they are still pending approval (should be rejected instead).
export function isWorkOrderClosable(workOrder: any): boolean {
  if (!workOrder) {
    return false;
  }

  const requiresToc = !!workOrder.tocRequired;
  const isApproved = workOrder.approvalStatus === 'APPROVED';
  const isOpenOrClosed = workOrder.status === 'OPEN' || workOrder.status === 'CLOSED';

  return !requiresToc && isApproved && !isOpenOrClosed;
}
